<template>
    <v-app>
        <v-main>
            <v-container>
                <v-layout justify-center>
                    <v-flex xs12 sm12 md12 lg12 xl12>
                        <v-card>
                            <v-card-title class="pb-5">
                                <!--                                    v-if="$can('transaction_create')"-->
                                <v-btn to="/content" rounded color="#A5668B" class="text-white">
                                    <v-icon>mdi-backspace-reverse-outline</v-icon>
                                    بازگشت
                                </v-btn>
                                <v-spacer/>
                                افزودن محتوا
                                <v-spacer/>
                                <v-btn @click="addContent" color="#50858B" rounded
                                       class="text-white">
                                    <v-icon>mdi-content-save</v-icon>
                                    ذخیره
                                </v-btn>
                                <!--                            <v-card elevation="2" outlined>-->
                            </v-card-title>


                            <v-card-text>
                                <v-row>
                                    <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                                        <v-text-field
                                            :rules="rules.title"
                                            v-model="title"
                                            autofocus
                                            :error-messages="errors.name"
                                            label="عنوان"
                                            required
                                            outlined
                                            dense
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                                        <v-select
                                            v-model="service"
                                            :rules="rules.service"
                                            :items="services"
                                            :error-messages="errors.service"
                                            item-text="nameLand"
                                            item-value="id"
                                            label="انتخاب سرویس"
                                            outlined
                                            dense
                                            return-object
                                        ></v-select>
                                    </v-flex>

                                    <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                                        <v-select
                                            v-model="type"
                                            :rules="rules.type"
                                            :items="types"
                                            item-text="value"
                                            item-value="name"
                                            label="نوع محتوا"
                                            outlined
                                            dense
                                            return-object
                                        ></v-select>
                                    </v-flex>
                                </v-row>
                                <v-row>
                                    <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                                        <v-text-field
                                            v-model="link"
                                            label="پیوند"
                                            outlined
                                            dense
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                                        <v-text-field
                                            v-model="sortOrder"
                                            :error-messages="errors.sort_order"
                                            label="اولویت نمایش"
                                            outlined
                                            dense
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                                        <v-file-input
                                            v-model="picture"
                                            label="تصویر محتوا"
                                            :error-messages="errors.picture"
                                            outlined
                                            dense
                                            prepend-icon="mdi-camera"
                                        ></v-file-input>

                                    </v-flex>
                                </v-row>
                                <v-row>
                                    <v-container fluid>
<!--                                        <v-textarea-->
<!--                                            v-model="description"-->
<!--                                            autocomplete="email"-->
<!--                                            :error-messages="errors.description"-->
<!--                                            label="توضیحات"-->
<!--                                            outlined-->
<!--                                            dense-->
<!--                                        ></v-textarea>-->

                                        <ckeditor :editor="editor.editor" v-model="description" :config="editor.editorConfig">

                                        </ckeditor>

                                    </v-container>

                                </v-row>

                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditorUploadAdapterPlugin from "../../../core/plugins/CKEditorUploadFileAdapter";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

export default {

    props: ["id"],
    data() {
        return {
            roleEdit: [],
            editor: {
                editor: ClassicEditor,
                editorConfig: {
                    extraPlugins: [CKEditorUploadAdapterPlugin],
                }
            },
            service: null,
            type: null,
            services: [],
            permissions: [],
            permissionIds: [],
            query: {sort: 'id', order: 'desc', limit: 100, s: ''},
            rules: {
                title: [val => (val || '').length > 0 || 'فیلد عنوان الزامی می باشد'],
                services: [val => val.length > 0 || 'فیلد سرویس الزامی می باشد'],
                type: [val => !! val || 'فیلد نوع محتوا الزامی می باشد'],
            },
            types: [
                {name: 'popup', value: 'پاپ اپ'},
                {name: 'header', value: 'سربرگ'},
                {name: 'news', value: 'اخبار'},
                {name: 'tag', value: 'برچسب'},
                {name: 'banner', value: 'بنر'},
                {name: 'support_link', value: 'پیوند پشتیبانی'},
                {name: 'company_links', value: 'پیوند شرکت'},
                {name: 'useful_links', value: 'پیوند های مفید'},
                {name: 'brand', value: 'برند'},
            ],
            title: '',
            description: '',
            picture: [],
            link: '',
            sortOrder: '',
            errors: [],
        }
    },

    mounted() {
      this.keydown('addContent')
        this.services = this.getService().data
      this.$store.dispatch(SET_BREADCRUMB, [{title: this.$route.meta.title}])
    },
    methods: {

        addContent() {
            if (this.service == null) {
                return this.$toast.error('لطفا سرویس را انتخاب کنید.')
            }
            if (this.type == null) {
                return this.$toast.error('لطفا نوع محتوا را انتخاب کنید.')
            }
            let formData = new FormData();
            formData.append('service_id', this.service.id)
            formData.append('type', this.type.name)
            formData.append('title', this.title)
            formData.append('description', this.description)
            formData.append('picture', this.picture)
            formData.append('link', this.link)
            formData.append('sort_order', this.sortOrder)
            this.requestApiPost(`content`, formData, this.configurationFile()
            ).then(response => {
                this.$toast.success('نقش با موفقیت اضافه شد.')
                this.goReplace('content')
            }).catch(e => {
                this.errors = e.response.data.errors
            })

        },

    },
}
</script>
